var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconsLoginPatient(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(38.68 32.075)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#AFF1D1",
    x: 20.049,
    width: 33.486,
    height: 33.819,
    rx: 16.743
  }), /*#__PURE__*/React.createElement("path", {
    d: "m33.437 77.427 6.99.018a28.385 28.385 0 0 0 27.478-20.989L72.02 41.21a4.613 4.613 0 0 0-4.442-5.814l-61.51-.153a4.613 4.613 0 0 0-4.46 5.836l4.185 15.22a28.748 28.748 0 0 0 27.644 21.128z",
    fill: "#EBFBF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.013 111.32h19.559a5.92 5.92 0 0 0 5.842-6.872l-3.356-20.57a5.92 5.92 0 0 0-5.842-4.967H30.369a5.92 5.92 0 0 0-5.842 4.966l-3.356 20.571a5.92 5.92 0 0 0 5.842 6.873z",
    fill: "#AFF1D1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsLoginPatient);
export default __webpack_public_path__ + "static/media/icons_login_patient.ca92acb79ad1dc0047eead59672ea14a.svg";
export { ForwardRef as ReactComponent };